import React from 'react';
import Icon from '../../../components/AppIcon';

const ConversionFilters = ({
  dateRange,
  onDateRangeChange,
  selectedSegment,
  onSegmentChange,
  selectedCohort,
  onCohortChange
}) => {
  const segments = [
    { value: 'all', label: 'All Segments' },
    { value: 'new_users', label: 'New Users (0-7 days)' },
    { value: 'active_users', label: 'Active Users (8-30 days)' },
    { value: 'power_users', label: 'Power Users (30+ days)' },
    { value: 'trial_users', label: 'Trial Users' },
    { value: 'feature_gate_encounters', label: 'Feature Gate Encounters' }
  ];

  const cohorts = [
    { value: 'all', label: 'All Cohorts' },
    { value: 'jan_2026', label: 'January 2026' },
    { value: 'dec_2025', label: 'December 2025' },
    { value: 'nov_2025', label: 'November 2025' },
    { value: 'oct_2025', label: 'October 2025' }
  ];

  const quickDateRanges = [
    { label: 'Last 7 Days', days: 7 },
    { label: 'Last 30 Days', days: 30 },
    { label: 'Last 90 Days', days: 90 }
  ];

  const handleQuickDateRange = (days) => {
    const end = new Date();
    const start = new Date();
    start?.setDate(start?.getDate() - days);
    
    onDateRangeChange({
      start: start?.toISOString()?.split('T')?.[0],
      end: end?.toISOString()?.split('T')?.[0]
    });
  };

  return (
    <div className="bg-card rounded-xl border border-border shadow-therapeutic p-4 sm:p-6 mb-6">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="Filter" size={20} className="text-primary" strokeWidth={2} />
        <h2 className="text-lg font-heading font-semibold text-foreground">
          Filter Analytics
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {/* User Segment Filter */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            User Segment
          </label>
          <select
            value={selectedSegment}
            onChange={(e) => onSegmentChange(e?.target?.value)}
            className="w-full px-3 py-2 bg-background border border-border rounded-lg text-foreground text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-smooth"
          >
            {segments?.map((segment) => (
              <option key={segment?.value} value={segment?.value}>
                {segment?.label}
              </option>
            ))}
          </select>
        </div>

        {/* Cohort Filter */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Cohort
          </label>
          <select
            value={selectedCohort}
            onChange={(e) => onCohortChange(e?.target?.value)}
            className="w-full px-3 py-2 bg-background border border-border rounded-lg text-foreground text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-smooth"
          >
            {cohorts?.map((cohort) => (
              <option key={cohort?.value} value={cohort?.value}>
                {cohort?.label}
              </option>
            ))}
          </select>
        </div>

        {/* Date Range Filter */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Date Range
          </label>
          <div className="flex gap-2">
            <input
              type="date"
              value={dateRange?.start}
              onChange={(e) => onDateRangeChange({ ...dateRange, start: e?.target?.value })}
              className="flex-1 px-3 py-2 bg-background border border-border rounded-lg text-foreground text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-smooth"
            />
            <input
              type="date"
              value={dateRange?.end}
              onChange={(e) => onDateRangeChange({ ...dateRange, end: e?.target?.value })}
              className="flex-1 px-3 py-2 bg-background border border-border rounded-lg text-foreground text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-smooth"
            />
          </div>
        </div>
      </div>

      {/* Quick Date Range Buttons */}
      <div className="flex flex-wrap gap-2 mt-4">
        <span className="text-sm text-muted-foreground mr-2">Quick select:</span>
        {quickDateRanges?.map((range) => (
          <button
            key={range?.days}
            onClick={() => handleQuickDateRange(range?.days)}
            className="px-3 py-1 text-xs font-medium bg-primary/10 text-primary rounded-lg hover:bg-primary/20 transition-smooth focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 focus:ring-offset-background"
          >
            {range?.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ConversionFilters;